import { defineComponent as _defineComponent } from 'vue'
import {
  getBrandIdentity,
  hasCompleteBrandIdentity,
} from '@/util/brandPlankIdentity'
import { matchHighlightBoardName } from '@/util/commonFun'
import { computed, withDefaults } from 'vue'

// eslint-disable-next-line no-unused-vars
type Func = (plank: any) => number


export default /*#__PURE__*/_defineComponent({
  __name: 'virtualListHead',
  props: {
    plank: null,
    border: { type: Boolean },
    selectBoxWidth: null,
    browserScrollShow: { type: Boolean },
    browserScrollWidth: null,
    filterAmount: { type: Function, default: () => ({} as any) },
    filterArea: { type: Function, default: () => ({} as any) },
    tableHeadProp: null,
    borderColor: null,
    align: null,
    rowIndex: null,
    preffixID: { default: 'list' }
  },
  emits: ["changeSelectAll", "toggleFold"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'changeSelectAll', plank: any): void
  (e: 'toggleFold', plank: any): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { plank: any, border: boolean, selectBoxWidth: number, browserScrollShow: boolean, browserScrollWidth: number, filterAmount: Func, filterArea: Func, tableHeadProp?: any, borderColor: string, align: 'left' | 'center', rowIndex: number, preffixID: string }


const selectBoxWidth = computed(() => {
  const select = props.tableHeadProp ? props.tableHeadProp[0] : {}
  return select?.width ?? '32px'
})

const plank = computed(() => {
  return props.plank
})

const isBrandPlank = computed(() =>
  hasCompleteBrandIdentity(plank.value.parts[0] || [])
)
const brandName = computed(
  () => getBrandIdentity(plank.value.parts[0] || []).brandName
)
function changeSelectAll() {
  emits('changeSelectAll', plank.value)
}
function changeFold(plank: any, index: number) {
  emits('toggleFold', plank)
}

return { __sfc: true,props, selectBoxWidth, emits, plank, isBrandPlank, brandName, changeSelectAll, changeFold, matchHighlightBoardName }
}

})